export class SkipTreeException extends Error {
}
export class ParseException {
    constructor(message, context) {
        this.message = message;
        if (context !== undefined) {
            this.message +=
                '<br><br>' +
                    'Error context:<br> "... ' +
                    context.left +
                    "<span class='cursor'>" +
                    context.at +
                    '</span>' +
                    context.right +
                    ' ... "';
        }
    }
}
